import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function MapFlyController({ flyTarget }) {
  const map = useMap();

  useEffect(() => {
    if (!flyTarget) {
      return;
    }

    map.flyTo([flyTarget.lat, flyTarget.lng], 15, {
      animate: true,
      duration: 0.8
    });
  }, [flyTarget, map]);

  return null;
}
